import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN = '[IncidentsModul] PostIncidentVorlageAktualisierenAdmin laden';
export const POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN_AUSFUEHREN = '[IncidentsModul] PostIncidentVorlageAktualisierenAdmin ausführen';
export const POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN_ERFOLGREICH = '[IncidentsModul] PostIncidentVorlageAktualisierenAdmin laden erfolgreich';
export const POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN_FEHLER = '[IncidentsModul] PostIncidentVorlageAktualisierenAdmin Ladefehler';
export const POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[IncidentsModul] PostIncidentVorlageAktualisierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostIncidentVorlageAktualisierenAdminAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN;
        constructor(public incidentVorlageDatenRequest: api.IncidentVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageAktualisierenAdminAusfuehrenAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN_AUSFUEHREN;
        constructor(public incidentVorlageDatenRequest: api.IncidentVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageAktualisierenAdminErfolgreichAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.IncidentVorlageIdentifier, public incidentVorlageDatenRequest: api.IncidentVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageAktualisierenAdminFehlerAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public incidentVorlageDatenRequest: api.IncidentVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageAktualisierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsCommandIncidentVorlageAktualisierenAdminActions =
    PostIncidentVorlageAktualisierenAdminAction
    | PostIncidentVorlageAktualisierenAdminAusfuehrenAction
    | PostIncidentVorlageAktualisierenAdminErfolgreichAction
    | PostIncidentVorlageAktualisierenAdminFehlerAction
    | PostIncidentVorlageAktualisierenAdminNichtAusgefuehrtAction
    ;
